// project import
import dashboard from './dashboard';

// project imports
import { MenuItems } from 'types/menu';

// ==============================|| MENU ITEMS ||============================== //

const menuItems: MenuItems = {
  items: [dashboard]
};

export default menuItems;
